// src/router.js
import {
  createBrowserRouter,
  Navigate
} from "react-router-dom";
import Login from "../auth/Login";
import Register from "../auth/Register";
import LinkDriver from "../page/LinkDriver";
import Layout from "../component/Layout";
import Operation from "../page/Operation";
import Settings from "../page/Settings";
import DriverRegistrationRequest from "../page/DriverRegistrationRequest";
import StoresList from "../page/StoresList";
import Orders from "../page/Orders";
import DriverList from "../page/DriverList";
import TrackingDriver from "../page/TrackingDriver";
import Items from "../page/Items";
import OrderItems from '../page/OrderItems';
import Profile from '../page/Profile';
import Contacted from '../page/Contacted';
import OrdersPending from '../page/OrderPending';
import DeleteAccount from '../page/DeleteAccount';
import TermsConditions from '../page/TermsConditions';
import TermsConditionsPrivacyPolicyView from '../page/TermsConditionsView';
import SessionUtil from '../util/SessionUtil';

const withLayout = (element) => <Layout>{element}</Layout>;

const ProtectedRoute = (children, isAllowed) => {
  return isAllowed ? children : <Navigate to="/" replace />;
};

const userType = SessionUtil.getTypeUser();
const isLoggedIn = SessionUtil.isLoggedIn();

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: isLoggedIn
        ? userType === "4" || userType === "2"
          ? <Navigate to="/driver-list" />
          : userType === "1"
            ? <Navigate to="/operation" />
            : <Login />
        : <Login />
    },
    {
      path: "/register",
      element: ProtectedRoute(withLayout(<Register />), isLoggedIn && userType === "4"),
    },
    {
      path: "/link-driver",
      element: ProtectedRoute(withLayout(<LinkDriver />), isLoggedIn && userType === "4"),
    },
    {
      path: "/operation",
      element: ProtectedRoute(withLayout(<Operation />), isLoggedIn && userType === "1"),
    },
    {
      path: "/settings",
      element: ProtectedRoute(withLayout(<Settings />), isLoggedIn && userType === "4"),
    },
    {
      path: "/driver-registration-request",
      element: ProtectedRoute(withLayout(<DriverRegistrationRequest />), isLoggedIn && userType === "4"),
    },
    {
      path: "/stores-list",
      element: ProtectedRoute(withLayout(<StoresList />), isLoggedIn && ["4", "2"].includes(userType)),
    },
    {
      path: "/driver-list",
      element: ProtectedRoute(withLayout(<DriverList page="driver-list" />), isLoggedIn && ["4", "2"].includes(userType)),
    },
    {
      path: "/live-driver-list",
      element: ProtectedRoute(withLayout(<DriverList page="live-driver-list" />), isLoggedIn && userType === "4"),
    },
    {
      path: "/Orders/:type/:id",
      element: ProtectedRoute(withLayout(<Orders />), isLoggedIn && ["4", "2"].includes(userType)),
    },
    {
      path: "/stores-items/:type/:id",
      element: ProtectedRoute(withLayout(<Items />), isLoggedIn && ["4", "2"].includes(userType)),
    },
    {
      path: "/order-items/:type/:id",
      element: ProtectedRoute(withLayout(<OrderItems />), isLoggedIn && ["4", "2"].includes(userType)),
    },
    {
      path: "/tracking-driver/:id",
      element: ProtectedRoute(withLayout(<TrackingDriver />), isLoggedIn && ["4", "1"].includes(userType)),
    },
    {
      path: "/profile",
      element: ProtectedRoute(withLayout(<Profile />), isLoggedIn && ["1", "2", "4"].includes(userType)),
    },
    {
      path: "/contact-us",
      element: ProtectedRoute(withLayout(<Contacted />), isLoggedIn && userType === "4"),
    },
    {
      path: "/Orders-pending",
      element: ProtectedRoute(withLayout(<OrdersPending />), isLoggedIn && userType === "4"),
    },
    {
      path: "/delete-account",
      element: <DeleteAccount />,
    },
    {
      path: "/terms-conditions",
      element: ProtectedRoute(withLayout(<TermsConditions />), isLoggedIn && userType === "4"),
    },
    {
      path: "/terms-conditions-store",
      element: <TermsConditionsPrivacyPolicyView page="store" type="TermsConditions" />,
    },
    {
      path: "/terms-conditions-user",
      element: <TermsConditionsPrivacyPolicyView page="user" type="TermsConditions" />,
    },
    {
      path: "/terms-conditions-driver",
      element: <TermsConditionsPrivacyPolicyView page="driver" type="TermsConditions" />,
    },
    {
      path: "/privacy-policy-store",
      element: <TermsConditionsPrivacyPolicyView page="store" type="PrivacyPolicy" />,
    },
    {
      path: "/privacy-policy-user",
      element: <TermsConditionsPrivacyPolicyView page="user" type="PrivacyPolicy" />,
    },
    {
      path: "/privacy-policy-driver",
      element: <TermsConditionsPrivacyPolicyView page="driver" type="PrivacyPolicy" />,
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true, // لحل تحذير splat
    },
  }
);
